<div class="content-container mb-3">
  @if (checkoutFinalize.showSignature) {
    <mwp-benefit-enrollment-checkout-finalize-signature (emitCancel)="signatureCancel()" (emitComplete)="signatureComplete($event)" />
  }
  @if (checkoutFinalize.showOTPCode) {
    <mwp-benefit-enrollment-checkout-finalize-otp [checkoutFinalize]="checkoutFinalize" (emitComplete)="otpComplete()" />
  }
</div>
<div>
  <mwp-benefit-enrollment-wizard-control [isCheckout]="true" [isContinueDisabled]="!isComplete" (emitComplete)="complete()" />
</div>